
const messages = {
    en: {
       delivery: {
          branch: {
            name: 'Branch',
            title: 'Branch management',
            subtitle: 'View, search, create, edit and delete Branch',
            creating: 'Creating Branch',
            editing: 'Editing Branch',
            deleting: 'Deleting Branch',
            showing: 'Showing Branch',
            menu: 'Branch',
            labels: {
                name: 'Name',
                isDefault: 'Is default'
            },

          }
       }
    },
    es: {
       delivery: {
          branch: {
            name: 'Sucursal',
            title: 'Administración de sucursales',
            subtitle: 'Ver, buscar, crear, editar, y borrar sucursales',
            creating: 'Creando Sucursal',
            editing: 'Modificando Sucursal',
            deleting: 'Eliminando Sucursal',
            showing: 'Detalles de Sucursal',
            menu: 'Sucursales',
            labels: {
                name: 'Nombre',
                isDefault: 'Por defecto'
            },

          }
       }
    },
    pt: {
       delivery: {
          branch: {
            name: 'Sucursal',
            title: 'Administração de Branch',
            subtitle: 'Ver, buscar, criar, editar e usar Branch',
            creating: 'Criando Branch',
            editing: 'Edição Branch',
            deleting: 'Apagando Branch',
            showing: 'Detalhes do Branch',
            menu: 'Branch',
            labels: {
                name: 'Nome',
                isDefault: 'Is default'
            },

          }
       }
    }
}

export default messages
